<script setup>
  defineOptions({
    name: "Logo",
  });
</script>

<template>
  <img class="p-1 sm:hidden" src="@images/logo/mc_icon.svg" width="40" alt="MediCheck" />

  <img
    v-if="$page.props?.client?.license?.license_name === 'connect-pro'"
    class="hidden h-12 p-1 sm:block"
    src="@images/logo/mc_logo_connect_pro.svg"
    alt="MediCheck"
  />

  <img
    v-else-if="$page.props?.client?.license?.license_name === 'connect-core'"
    class="hidden h-12 p-1 sm:block"
    src="@images/logo/mc_logo_connect_core.svg"
    alt="MediCheck"
  />

  <img
    v-else-if="$page.props?.client?.license?.license_name === 'online-pro'"
    class="hidden h-12 p-1 sm:block"
    src="@images/logo/mc_logo_online_pro.svg"
    alt="MediCheck"
  />

  <img v-else class="hidden h-12 p-1 sm:block" src="@images/logo/mc_logo.svg" alt="MediCheck" />
</template>
